// chatActions.js
export const LOAD_DASHBOARD = '@DASHBOARD/LOAD_DASHBOARD';
export const DASHBOARD_LOADED = '@DASHBOARD/DASHBOARD_LOADED';

export const loadDashboard = () => ({ type: LOAD_DASHBOARD });
export const dashboardLoaded = (dashboard) => ({ type: DASHBOARD_LOADED, payload: dashboard });

